import { useMemo } from 'react';
import { buildLobbyMarketGroups } from '@/utils';

interface UseLobbyMarketGroupsProps {
	markets: any[];
	userTrades: any[];
	tradesByMarket: Record<string, any>;
	lobbyId: string | undefined;
	isSurvivorMode: boolean;
	isCrowdLockMode: boolean;
}

export function useLobbyMarketGroups({
	markets,
	userTrades,
	tradesByMarket,
	lobbyId,
	isSurvivorMode,
	isCrowdLockMode,
}: UseLobbyMarketGroupsProps) {
	const groups = useMemo(
		() =>
			buildLobbyMarketGroups(
				markets,
				userTrades,
				tradesByMarket,
				lobbyId,
				isSurvivorMode,
				isCrowdLockMode
			),
		[markets, userTrades, tradesByMarket, isSurvivorMode, isCrowdLockMode, lobbyId]
	);

	return { groups };
}
